<template>
  <div style="width: 80%;position: relative;" :key="componentKey">
    <div class="itinerary-right-list" ref="listDom" :id="`pdf-CHElegant${pdfIndex}`" contenteditable="true" v-for="item,pdfIndex in store.state.dataTickets" :key="pdfIndex" style="position: absolute;z-index: 1;top:0;right:0;">
      <div>
        <div id="template" style="font-family: 宋体; font-size: 10pt">
          <table
            style="border-collapse: collapse"
            border="0"
            cellspacing="0"
            cellpadding="0"
            width="99%"
            align="center"
            class="cke_show_border CHElegant-box"
          >
            <tbody>
              <tr>
                <td align="left" width="45%">
                  <br />
                  <pre><span id="officeName"></span></pre>
                  <pre></pre>
                  <div style="display: inline">
                    <span id="officeAddr"></span>
                  </div>
                  <br />{{
                    store.state.seledLetter == "chdianya" ? "电话" : "Tel"
                  }}&nbsp;：&nbsp;<span id="officeTel" contenteditable="true"
                    >{{ store.state.phone }} </span
                  ><br />{{
                    store.state.seledLetter == "chdianya" ? "传真" : "Fax"
                  }}&nbsp;：&nbsp;<span id="officeFax" contenteditable="true">
                    {{ store.state.fax }} </span
                  ><br />{{
                    store.state.seledLetter == "chdianya" ? "代理人" : "Agent"
                  }}&nbsp;：&nbsp;<span id="name" contenteditable="true"
                    >{{ store.state.adminName }}
                  </span>
                </td>
                <td width="35%"><br /></td>
                <td
                  id="iataimage"
                  align="middle"
                  width="45%"
                  style="display: none"
                >
                  <br />
                </td>
              </tr>
            </tbody>
          </table>
          <table
            style="
              border-right: 0px dashed;
              border-top: 0px dashed;
              border-left: 0px dashed;
              border-bottom: #000000 1px dashed;
            "
            cellspacing="0"
            cellpadding="0"
            width="99%"
            align="center"
            class="cke_show_border CHElegant-box"
          >
            <tbody>
              <tr>
                <td><br /></td>
              </tr>
            </tbody>
          </table>
          <br />
          <div align="center" style="width: 100%; text-align: center">
            <pre>{{
              store.state.seledLetter == "chdianya"
                ? "行&nbsp;程&nbsp;单"
                : "Itinerary"
            }}</pre>
          </div>
          <br /><strong v-if="store.state.seledPDF == 'many'"
            ><span
              >{{
                store.state.seledLetter == "chdianya"
                  ? "尊敬的"
                  : "Dear traveller"
              }}&nbsp;</span
            >
            <span
              v-for="(item, index) in store.state.resolveData.Tickets"
              :key="index"
            >
              {{ item.PersonName }} </span
            >:</strong
          >
          <strong v-if="store.state.seledPDF == 'one'" ref="aaDom"><span
              >{{
                store.state.seledLetter == "chdianya"
                  ? "尊敬的"
                  : "Dear traveller"
              }}&nbsp;</span
            >
            <span
              id="passengerNameList" ref="personNameDom"
            >
              {{ store.state.dataTickets[pdfIndex].PersonName }} </span
            >:</strong>
          <br />
          <div
            style="width: 100%; text-align: start"
            v-html="
              store.state.seledLetter == 'chdianya'
                ? '感谢您选择我公司为您安排的旅行行程。以下是您此次行程的具体航班信息，请查收：'
                : 'thank you for booking with us。\r Please kindly find the flight schedule as well as other information:'
            "
          ></div>
          <br />
          <pre><strong>{{store.state.seledLetter == 'chdianya' ? '记录编号':'Booking Reference'}}</strong>：<span id="1EPNRNo">{{store.state.resolveData.Pnr}}</span></pre>
          <pre><strong>{{store.state.seledLetter == 'chdianya' ? '航司编码':'Airline PNR'}}</strong>：<span id="bigCodes">{{store.state.resolveData.AirlineBigCode}}</span></pre>
          <strong
            >{{
              store.state.seledLetter == "chdianya"
                ? "旅客信息"
                : "PassengerInfo"
            }}：</strong
          >
          <p><br /></p>
          <div id="passengerList">
            <table
              style="
                border-collapse: collapse;
                width: 700px;
                table-layout: fixed;
                word-wrap: break-word;
                word-break: break-all;
              "
              bordercolor="black"
              cellspacing="0"
              cellpadding="0"
              width="80%"
              align="center"
              border="1"
              bgcolor="#ccccff"
            >
              <tbody>
                <tr align="middle" class="passenger-title">
                  <td width="185px;" height="22">
                    <strong>{{
                      store.state.seledLetter == "chdianya"
                        ? "旅客姓名"
                        : "Name"
                    }}</strong>
                  </td>
                  <td width="90px" height="22">
                    <strong>{{
                      store.state.seledLetter == "chdianya"
                        ? "证件类型"
                        : "Cert Type"
                    }}</strong>
                  </td>
                  <td width="150px" height="22">
                    <strong>{{
                      store.state.seledLetter == "chdianya"
                        ? "证件号"
                        : "Cert No"
                    }}</strong>
                  </td>
                  <td width="150px" height="22">
                    <strong>{{
                      store.state.seledLetter == "chdianya"
                        ? "常客卡号"
                        : "FQCard No"
                    }}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
            <div id="passengerInfo">
              <table
                style="
                  border-collapse: collapse;
                  width: 700px;
                  word-wrap: break-word;
                  word-break: break-all;
                "
                bordercolor="black"
                cellspacing="0"
                cellpadding="0"
                width="80%"
                align="center"
                border="1"
              >
                <tbody v-if="store.state.seledPDF == 'many'">
                  <tr
                    align="middle"
                    v-for="(item, index) in store.state.resolveData.Tickets"
                    :key="index"
                  >
                    <td width="185px" height="22">
                      <span>{{ item.PersonName }}</span>
                    </td>
                    <td width="90px" height="22">
                      <span v-if="store.state.seledLetter == 'chdianya'">{{item.CertificateType}}</span>
                      <span v-if="store.state.seledLetter !== 'chdianya'">{{item.CertificateTypeEN}}</span>
                    </td>
                    <td width="150px" height="22">
                      <span>{{ item.Certificate }}</span>
                    </td>
                    <td width="150px" height="22">
                      <span> {{item.FQcard}} </span>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="store.state.seledPDF == 'one'">
                  <tr
                    align="middle"
                  >
                    <td width="185px" height="22">
                      <span id="passengerName">{{ store.state.dataTickets[pdfIndex].PersonName }}</span>
                    </td>
                    <td width="90px" height="22">
                      <span id="certType" v-if="store.state.seledLetter == 'chdianya'">{{item.CertificateType}}</span>
                      <span id="certType" v-if="store.state.seledLetter !== 'chdianya'">{{item.CertificateTypeEN}}</span>
                    </td>
                    <td width="150px" height="22">
                      <span id="certNo">{{ store.state.dataTickets[pdfIndex].Certificate }}</span>
                    </td>
                    <td width="150px" height="22">
                      <span id="ftCardNo"> {{item.FQcard}} </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!--{cke_protected}{C}%3C!%2D%2D%20%E4%BB%A5%E4%B8%8A%E6%98%AF%E6%97%85%E5%AE%A2%E4%BF%A1%E6%81%AF%20%2D%2D%3E--><strong
            >{{
              store.state.seledLetter == "chdianya"
                ? "航班信息"
                : "SegmentInfo"
            }}：</strong
          >
          <p><br /></p>
          <div
            id="segmentInfo"
            v-for="(item, index) in store.state.resolveData.Flights"
            :key="index"
          >
            <table
              style="
                border-right: #000000 1px solid;
                border-top: #000000 1px solid;
                border-left: #000000 1px solid;
                border-bottom: #000000 0px solid;
                width: 700px;
                table-layout: fixed;
                word-wrap: break-word;
                word-break: break-all;
              "
              cellspacing="0"
              cellpadding="3"
              align="center"
              bgcolor="#ccccff"
              class="cke_show_border"
            >
              <tbody>
                <tr>
                  <td align="left">
                    {{
                      store.state.seledLetter == "chdianya" ? "第" : "Itinerary"
                    }}
                    <span id="segmentIndex">{{ index + 1 }}</span
                    >{{ store.state.seledLetter == "chdianya" ? "段" : "" }}
                    <span id="segmentType">{{
                      store.state.seledLetter == "chdianya"
                        ? "普通航段"
                        : "Normal segment"
                    }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              style="
                border-right: #000000 1px solid;
                border-top: #000000 1px solid;
                border-left: #000000 1px solid;
                border-bottom: #000000 1px solid;
                width: 698px;
                word-wrap: break-word;
                word-break: break-all;
              "
              cellspacing="0"
              cellpadding="3"
              align="center"
              bgcolor="#f0f0f0"
              class="cke_show_border"
            >
              <tbody>
                <tr>
                  <td align="middle" width="84px">
                    <strong
                      >{{
                        store.state.seledLetter == "chdianya" ? "日期" : "Date"
                      }}: </strong
                    >
                  </td>
                  <td style="width: 265px; text-align: start">
                    <span id="travelDate"  v-if="store.state.seledLetter == 'chdianya'">{{ judgmentDate(item.FlightDate.slice(2)) == undefined ? item.FlightDate : judgmentDate(item.FlightDate.slice(2))+ '-' + item.FlightDate.slice(0,2) }}</span>
                    <span id="travelDate"  v-if="store.state.seledLetter !== 'chdianya'">{{ item.FlightDate}}</span>
                  </td>
                  <td align="middle" width="84px">
                    <strong
                      >{{
                        store.state.seledLetter == "chdianya"
                          ? "经停"
                          : "Stopover"
                      }}: </strong
                    >
                  </td>
                  <td style="text-align: start"><span id="stops"></span></td>
                </tr>
                <tr>
                  <td align="middle">
                    <strong
                      >{{
                        store.state.seledLetter == "chdianya"
                          ? "航班"
                          : "Flight No"
                      }}: </strong
                    >
                  </td>
                  <td style="text-align: start">
                    <span id="flightNo">{{ item.Flight }}</span
                    >&nbsp; - &nbsp;<span id="airlineName"></span>
                  </td>
                  <td align="middle">
                    <strong
                      >{{
                        store.state.seledLetter == "chdianya"
                          ? "机型"
                          : "Aerocraft"
                      }}: </strong
                    >
                  </td>
                  <td style="text-align: start">
                    <span id="planeType"></span>
                  </td>
                </tr>
                <tr>
                  <td align="middle">
                    <strong
                      >{{
                        store.state.seledLetter == "chdianya" ? "舱位" : "Class"
                      }}: </strong
                    >
                  </td>
                  <td style="text-align: start">
                    <span id="cabin">{{ item.Position }}</span
                    ><span id="seat"></span>
                  </td>
                  <td align="middle">
                    <strong
                      >{{
                        store.state.seledLetter == "chdianya"
                          ? "状态"
                          : "Status"
                      }}: </strong
                    >
                  </td>
                  <td style="text-align: start">
                    <span id="actionCode">{{ item.FlightStatus }}</span>
                  </td>
                </tr>
                <tr>
                  <td align="middle">
                    <strong
                      >{{
                        store.state.seledLetter == "chdianya" ? "起飞" : "Dep"
                      }}: </strong
                    >
                  </td>
                  <td colspan="2" style="text-align: start">
                    <span id="departureTime">{{
                      item.DepartureTime.slice(0, 2) +
                      ":" +
                      item.DepartureTime.slice(2, 4)
                    }}</span
                    >&nbsp;{{
                      store.state.seledLetter == "chdianya"
                        ? "(当地时间)"
                        : "(Local time)"
                    }}
                    &nbsp;
                    <span id="departureCityName">{{ item.Departure }}</span
                    >&nbsp;&nbsp;<span id="depAirportTerminal">{{
                      item.DepartureTerminal || item.DepartureTerminal == ""
                        ? "--"
                        : item.DepartureTerminal
                    }}</span>
                  </td>
                  <td id="departureCityWeather" align="left"><br /></td>
                </tr>
                <tr>
                  <td align="middle">
                    <strong
                      >{{
                        store.state.seledLetter == "chdianya" ? "到达" : "Arr"
                      }}: </strong
                    >
                  </td>
                  <td colspan="2" style="text-align: start">
                    <span id="arrivalTime">{{
                      item.DestinationTime.slice(0, 2) +
                      ":" +
                      item.DestinationTime.slice(2, 4) +(item.ModifyDate == 0 ? '':'+' + item.ModifyDate)
                    }}</span
                    >&nbsp;{{
                      store.state.seledLetter == "chdianya"
                        ? "(当地时间)"
                        : "(Local time)"
                    }}
                    &nbsp;
                    <span id="arrivalCityName">{{ item.Destination }}</span>
                    &nbsp;&nbsp;<span
                      id="arrAirportTerminal"
                      >{{
                        item.DestinationTerminal ||
                        item.DestinationTerminal == ""
                          ? "--"
                          : item.DestinationTerminal
                      }}</span
                    >
                  </td>
                  <td id="arrivalCityWeather" align="left"><br /></td>
                </tr>
                <tr>
                  <td align="middle">
                    <strong
                      >{{
                        store.state.seledLetter == "chdianya"
                          ? "飞行"
                          : "Duration"
                      }}: </strong
                    >
                  </td>
                  <td style="text-align: start">
                    <span id="elapsedTime"></span>
                  </td>
                  <td align="middle">
                    <strong
                      >{{
                        store.state.seledLetter == "chdianya" ? "餐食" : "Meal"
                      }}: </strong
                    >
                  </td>
                  <td style="text-align: start"><span id="mealFlag"></span></td>
                </tr>
                <tr>
                  <td align="middle">
                    <strong
                      >{{
                        store.state.seledLetter == "chdianya"
                          ? "行李"
                          : "Baggage"
                      }}: </strong
                    >
                  </td>
                  <td style="text-align: start">
                    <span id="baggageWeight">{{ item.Luggage == '0' ? '': item.Luggage}}</span>
                  </td>
                  <td align="middle"><br /></td>
                  <td><br /></td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />
          <pre>{{store.state.seledLetter == "chdianya"? '以上机票的价格为':'Air Fare'}}：<span id="currencyType_total"></span>&nbsp;&nbsp;<span id="totalAmount">{{allPrice}}</span>({{store.state.seledLetter == "chdianya"? '含税':'Include tax'}})</pre>
          <br />
          <div id="ei ">
            <strong
              >{{
                store.state.seledLetter == "chdianya" ? "限制条件" : "EI"
              }}：</strong
            >&nbsp;&nbsp;<span id="ticketCondition"></span>
          </div>
          <br />
          <div id="remark">
            <strong
              >{{
                store.state.seledLetter == "chdianya" ? "注释" : "Remark"
              }}：</strong
            >
            <div id="remark_tktAirline">
              &nbsp;&nbsp; -
              <span id="tktAirline_Name">{{
                store.state.resolveData.Airline
              }}</span
              >&nbsp;({{
                store.state.seledLetter == "chdianya"
                  ? "服务热线"
                  : "Service Hotline"
              }}：<span id="tktAirline_Tel">;</span>)
            </div>
          </div>
          <div id="tktl"><br /></div>
          <div id="tktInfo">
            <strong>{{
              store.state.seledLetter == "chdianya" ? "票号：" : "Ticket No："
            }}</strong>
            <div id="tktno">
              <ul style="list-style-type: circle" v-if="store.state.seledPDF == 'many'">
                <li
                  v-for="(item, index) in store.state.resolveData.Tickets"
                  :key="index"
                >
                  &nbsp;&nbsp;·
                  <span
                    >{{ item.PersonName + "："
                    }}{{ !item.TicketNo ? "" : item.TicketNo }}</span
                  ><br />&nbsp;&nbsp;<span id="etktNo"></span>
                </li>
              </ul>
              <ul style="list-style-type: circle" v-if="store.state.seledPDF == 'one'">
                <li
                >
                  &nbsp;&nbsp;·
                  <span id="PassengernameTktno"
                    >{{ store.state.dataTickets[pdfIndex].PersonName + "："
                    }}{{ !store.state.dataTickets[pdfIndex].TicketNo ? "" : store.state.dataTickets[pdfIndex].TicketNo }}</span
                  ><br />&nbsp;&nbsp;<span id="etktNo"></span>
                </li>
              </ul>
            </div>
            <br />
            <pre><strong>{{store.state.seledLetter == "chdianya"? '提醒您注意':'Note'}}：</strong>
&nbsp;&nbsp;{{store.state.seledLetter == "chdianya"? '国内航班请提前90分钟，国际航班请提前2个小时到达机场，办理乘机和安检手续。':'Please go to the check-in desk 90minutes/2hours before departure for domestic/international flight.'}}</pre>
          </div>
          <br />
          <div
            style="width: 100%; text-align: start;"
          ><strong style="display:block;">{{store.state.seledLetter == "chdianya"? '免责申明':'Liability Disclaimer'}}：</strong>
          <span>&nbsp;&nbsp;{{store.state.seledLetter == "chdianya"? '该内容仅供参考不作为值机依据。如遇航班号、起飞时间、舱位、机型等行程信息发生变更，':'This content will only serve as a reference.  In case of flight information change,the notice of airlines shall prevail.We are not responsibility to the loss of passengers occur with flight information change.'}}
{{store.state.seledLetter == "chdianya"? '请以航空公司实际公示信息为准，对此给乘机人造成的损失本公司不承担任何责任。':'(The above contents may be translated into other languages, but the Chinese version shall always prevail)'}}</span>
</div>
          <br /><br />
          <pre>
&nbsp;&nbsp;{{
              store.state.seledLetter == "chdianya"
                ? "若您在旅行过程中有任何需要解决的问题，请随时拨打我们的24小时免费电话 ****"
                : "Should you have any further information, please feel free to contact us at **** "
            }} </pre
          >
          <br /><br /><br />
          <div align="center" style="width: 100%; text-align: center">
            <pre><strong>{{store.state.seledLetter == "chdianya"? '祝您旅途愉快！':'Have a nice trip!'}}</strong></pre>
          </div>
        </div>
      </div>
      <p><br /></p>
    </div>

    <!--   ---------------------------------------------              ------------------------------------------- -->
  </div>
</template>

<script setup>
import { nextTick, onMounted, ref, watch } from "vue";
import htmlPdf from "@/utils/pdf.js";
import { useStore } from "vuex";

const store = useStore();
const CHElegantbox = ref(null);
const allPrice = ref("0");
const listDom = ref(null)
const personNameDom = ref(null)
const componentKey = ref(0)
const aaDom = ref(null)

function judgmentDate(text){
  let moonList = [
    {
      name:'JAN',
      num:'01'
    },
    {
      name:'FEB',
      num:'02'
    },
    {
      name:'MAR',
      num:'03'
    },
    {
      name:'APR',
      num:'04'
    },{
      name:'MAY',
      num:'05'
    },
    {
      name:'JUN',
      num:'06'
    },
    {
      name:'JUL',
      num:'07'
    },
    {
      name:'AUG',
      num:'08'
    },
    {
      name:'SEP',
      num:'09'
    },
    {
      name:'OCT',
      num:'10'
    },
    {
      name:'NOV',
      num:'11'
    },
    {
      name:'DEC',
      num:'12'
    }]
    let content = ''
  moonList.forEach((element)=>{
    if(element.name.toUpperCase() == text.toUpperCase()){
      content = element.num
    }
  })
  return content
}

function handleInput(){
}

function childPDF() {
  let TypeName = "电子行程单";
  // many是多人
  if(store.state.seledPDF=='many'){
     htmlPdf(TypeName, document.querySelector(`#pdf-CHElegant0`));
  }else {
    // 這個是獨立
    (store.state.dataTickets = store.state.resolveData.Tickets)
      nextTick(()=>{
        listDom.value.forEach((element1,index)=>{
        element1.innerHTML = listDom.value[0].innerHTML
        element1.querySelector('#passengerNameList').innerText = store.state.dataTickets[index].PersonName
        element1.querySelector('#passengerName').innerText = store.state.dataTickets[index].PersonName
        element1.querySelector('#certType').innerText = store.state.seledLetter == 'newChDianya' ? store.state.dataTickets[index].CertificateType : store.state.dataTickets[index].CertificateTypeEN
        element1.querySelector('#certNo').innerText = store.state.dataTickets[index].Certificate
        element1.querySelector('#PassengernameTktno').innerText = store.state.dataTickets[index].PersonName + "：" + (!store.state.dataTickets[index].TicketNo ? ";" : store.state.dataTickets[index].TicketNo+';');
        element1.querySelector("#ftCardNo").innerText = store.state.dataTickets[index].FQcard
      })
      })
      nextTick(()=>{
      store.state.dataTickets.forEach((element,index)=>{
        htmlPdf(element.PersonName +TypeName, document.querySelector(`#pdf-CHElegant${index}`));
      })
    })
    nextTick(()=>{
      componentKey.value = new Date()
      })
  }
}

onMounted(() => {});

defineExpose({
  childPDF,
});
</script>

<style scoped>
.itinerary-right-list {
  width: 100%;
  padding: 20px 0;
}

.itinerary-right-list:focus {
  border: 0;
  outline: none;
}

#pdf-CHElegant0{
  position: relative !important;
  z-index: 1000 !important;
  background-color: #fff;
  /* right: 32px !important; */
}

/* table.cke_show_border,
table.cke_show_border > tr > td,
table.cke_show_border > tr > th,
table.cke_show_border > tbody > tr > td,
table.cke_show_border > tbody > tr > th,
table.cke_show_border > thead > tr > td,
table.cke_show_border > thead > tr > th,
table.cke_show_border > tfoot > tr > td,
table.cke_show_border > tfoot > tr > th {
  border: #d3d3d3 1px dotted;
} */

#template {
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
}

#tktInfo {
  width: 100%;
  text-align: start;
}

#remark {
  width: 100%;
  text-align: start;
}

#passengerList,
#segmentInfo {
  width: 100%;
  margin: 0 auto;
}

#passengerList td {
  padding-bottom: 3px;
}
</style>